<div class="perf-overlay" *ngIf="visible">
  <div class="header">
    <span>Rendimiento</span>
    <div class="actions">
      <button type="button" class="btn-icon" (click)="toggle()" title="Ocultar/mostrar">_</button>
      <button type="button" class="btn-icon" (click)="close()" title="Cerrar">×</button>
    </div>
  </div>
  <div class="body" *ngIf="visible">
    <ng-container *ngIf="(stats$ | async) as s">
      <div class="row">
        <label>CPU</label>
        <div class="bar">
          <div class="fill" [style.width.%]="s.cpuLoadPct" [class.warn]="s.cpuLoadPct>60" [class.danger]="s.cpuLoadPct>85"></div>
        </div>
        <span class="val">{{ s.cpuLoadPct }}%</span>
      </div>
      <div class="row">
        <label>FPS</label>
        <span class="val">{{ s.fps }}</span>
      </div>
      <div class="row">
        <label>Lag</label>
        <span class="val">{{ s.eventLoopLagMs }} ms</span>
      </div>
      <div class="row">
        <label>LongTasks</label>
        <span class="val">{{ s.longTaskMs }} ms</span>
      </div>
      <div class="row">
        <label>RAM</label>
        <span class="val" *ngIf="s.memoryMB !== null; else noMem">
          {{ s.memoryMB | number:'1.0-0' }} MB
          <ng-container *ngIf="s.memoryLimitMB !== null"> / {{ s.memoryLimitMB | number:'1.0-0' }} MB ({{ s.memoryPct | number:'1.0-0' }}%)</ng-container>
        </span>
        <ng-template #noMem><span class="val">N/D</span></ng-template>
      </div>
    </ng-container>
  </div>
</div>
